import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../../framework/components/FullPageSpinner/FullPageSpinner';
import { spinnerOpen } from '../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { closeWebview } from './ClosePageUtils';

export class ClosePage extends Component {
    static propTypes = {
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
        closeWebview();
    }

    render() {
        return (<div />);
    }
}

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(spinnerOpen());
    }
});

export default connect(null, mapDispatchToProps)(ClosePage);
